import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a61976"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "countdown-bar__value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["countdown-bar", { small: _ctx.isSmall }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["countdown-bar__content", _ctx.colorClass]),
      style: _normalizeStyle(_ctx.barWidthStyle)
    }, null, 6),
    (!_ctx.isSmall)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.countdownText), 1))
      : _createCommentVNode("", true)
  ], 2))
}